module.exports = __webpack_public_path__ + "img/Pot3.a2d1a5ec.svg";